import { useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../routes/coach";
import { useSelector } from "react-redux";
import LogoutConfirmationModal from "../components/Modals/common/webinar/LogoutConfirmationModal";
import { enterPrisesPaths } from "../routes/enterprises";

const CoachMenuLayout = ({ children, user }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { coachProfile } = useSelector((state) => state.coach.coach || {});
  const profileImage =
    user?.profile_image ||
    coachProfile?.profile_image ||
    "/assets/img/user_profile.png";
  const composedName = [user?.first_name || coachProfile?.first_name, user?.last_name || coachProfile?.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  const profileName =
    user?.full_name ||
    coachProfile?.full_name ||
    composedName ||
    user?.email ||
    coachProfile?.email ||
    "";

  const handleLogout = () => {
    localStorage.removeItem("coach_token_nuvio");
    navigate(enterPrisesPaths?.Enterprise);
  };

  return (
    <>
      <div>
        <div class="ct_dash_header ct_px_40 ">
          <div class="ct_dash_logo">
            <a onClick={() => navigate(enterPrisesPaths?.Enterprise)}>
              <img src="/assets/img/Nuvio_logo.png" alt="" />
            </a>
          </div>
          <ul class="ct_right_dash_option">
            <li>
              <a>
                <i class="fa-solid fa-comment"></i>
              </a>
            </li>
            <li>
              <a>
                <i class="fa-solid fa-bell"></i>
              </a>
            </li>
            <li>
              <div class="ct_right_dropdown dropdown">
                <button
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div class="d-flex align-items-center">
                    <img
                      src={profileImage}
                      alt=""
                      class="ct_img_30"
                    />
                    {profileName ? <span class="ms-2">{profileName}</span> : null}
                  </div>
                  <i class="fa-solid fa-angle-down ms-auto"></i>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    <a
                      class="dropdown-item"
                      onClick={() => navigate(coachPaths.Profile)}
                    >
                      My Profile
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      onClick={() =>
                        navigate(coachPaths?.CoachSettings, {
                          state: { tab: "Security" },
                        })
                      }
                    >
                      Change Password
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#ct_coach_logout_admin"
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="ct_dash_nav ct_px_40">
          <ul>
            <li
              onClick={() => {
                navigate(coachPaths.CoachDashboard);
              }}
            >
              <a class={pathname == coachPaths.CoachDashboard ? "active" : ""}>
                Dashboard
              </a>
            </li>
            <li>
              <a>Calendar</a>
            </li>
            <li
              onClick={() => {
                navigate(coachPaths.coachCoaching);
              }}
            >
              <a class={pathname == coachPaths.coachCoaching ? "active" : ""}>
                Coaching
              </a>
            </li>
            <li
              onClick={() => {
                navigate(coachPaths.coach_resources);
              }}
            >
              <a class={pathname == coachPaths.coach_resources ? "active" : ""}>
                Resources
              </a>
            </li>
            <li
              onClick={() => {
                navigate(coachPaths.Event);
              }}
            >
              <a className={pathname == coachPaths.Event ? "active" : ""}>
                {" "}
                Events
              </a>
            </li>
            <li>
              <a>Community</a>
            </li>
            <li onClick={() => navigate(coachPaths.Profile)}>
              <a class={pathname == coachPaths.Profile ? "active" : ""}>Profile</a>
            </li>
            <li>
              <a>Inbox</a>
            </li>
            <li>
              <a>Wallet</a>
            </li>
            <li onClick={() => navigate(coachPaths?.CoachSettings)}>
              <a class={pathname == coachPaths.CoachSettings ? "active" : ""}>
                Settings{" "}
              </a>
            </li>
          </ul>
        </div>
        {children}
      </div>
      <LogoutConfirmationModal
        id="ct_coach_logout_admin"
        title="Logout"
        onConfirm={handleLogout}
      />
    </>
  );
};

export default CoachMenuLayout;

